module.exports = __webpack_public_path__ + "static/media/club-mastercard.f173e54f.png";